import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=363c6a2e&scoped=true"
import script from "./ProductInventory.vue?vue&type=script&lang=js"
export * from "./ProductInventory.vue?vue&type=script&lang=js"
import style0 from "./ProductInventory.vue?vue&type=style&index=0&id=363c6a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c6a2e",
  null
  
)

export default component.exports